/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { PostApiAuthBarberLoginMutationRequest, PostApiAuthBarberLoginMutationResponse, PostApiAuthBarberLogin400, PostApiAuthBarberLogin401, PostApiAuthBarberLogin409, PostApiAuthBarberLogin423 } from "../entities/PostApiAuthBarberLogin";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { postApiAuthBarberLogin } from "../api/postApiAuthBarberLogin";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const postApiAuthBarberLoginMutationKey = () => [{ url: '/api/auth/barber/login' }] as const

export type PostApiAuthBarberLoginMutationKey = ReturnType<typeof postApiAuthBarberLoginMutationKey>

export function postApiAuthBarberLoginMutationOptions<TContext = unknown>(config: Partial<RequestConfig<PostApiAuthBarberLoginMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = postApiAuthBarberLoginMutationKey()
        return mutationOptions<PostApiAuthBarberLoginMutationResponse, ResponseErrorConfig<PostApiAuthBarberLogin400 | PostApiAuthBarberLogin401 | PostApiAuthBarberLogin409 | PostApiAuthBarberLogin423>, {data: PostApiAuthBarberLoginMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return postApiAuthBarberLogin(data, config)
          },
        })

}

/**
 * @description Авторизация мастера по PIN-коду (6 цифр)
 * @summary Вход мастера
 * {@link /api/auth/barber/login}
 */
export function usePostApiAuthBarberLogin<TContext>(options: 
{
  mutation?: UseMutationOptions<PostApiAuthBarberLoginMutationResponse, ResponseErrorConfig<PostApiAuthBarberLogin400 | PostApiAuthBarberLogin401 | PostApiAuthBarberLogin409 | PostApiAuthBarberLogin423>, {data: PostApiAuthBarberLoginMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<PostApiAuthBarberLoginMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? postApiAuthBarberLoginMutationKey()

          const baseOptions = postApiAuthBarberLoginMutationOptions(config) as UseMutationOptions<PostApiAuthBarberLoginMutationResponse, ResponseErrorConfig<PostApiAuthBarberLogin400 | PostApiAuthBarberLogin401 | PostApiAuthBarberLogin409 | PostApiAuthBarberLogin423>, {data: PostApiAuthBarberLoginMutationRequest}, TContext>
          

          return useMutation<PostApiAuthBarberLoginMutationResponse, ResponseErrorConfig<PostApiAuthBarberLogin400 | PostApiAuthBarberLogin401 | PostApiAuthBarberLogin409 | PostApiAuthBarberLogin423>, {data: PostApiAuthBarberLoginMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<PostApiAuthBarberLoginMutationResponse, ResponseErrorConfig<PostApiAuthBarberLogin400 | PostApiAuthBarberLogin401 | PostApiAuthBarberLogin409 | PostApiAuthBarberLogin423>, {data: PostApiAuthBarberLoginMutationRequest}, TContext>
      
}